import { render, staticRenderFns } from "./AddContactComponent.vue?vue&type=template&id=5c518ae4&"
import script from "./AddContactComponent.vue?vue&type=script&lang=js&"
export * from "./AddContactComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports